import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';

export default function NotFound() {
  return (
    <main style={{ paddingTop: 64 }}>
      <SEOHead
        title="Page Not Found – DPOS"
        description="The page you are looking for does not exist. Return to DPOS – the best F&B and POS software."
        noindex={true}
      />
      <section style={{
        minHeight: 'calc(100vh - 200px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '80px 24px', textAlign: 'center',
        background: 'linear-gradient(135deg, #fff 0%, #fef2f2 100%)',
      }}>
        <div style={{ maxWidth: 520 }}>
          <p style={{
            fontSize: 120, fontWeight: 900, color: '#fecaca',
            lineHeight: 1, marginBottom: 16, letterSpacing: '-4px',
          }}>404</p>
          <h1 style={{ fontSize: 32, fontWeight: 800, color: '#111827', marginBottom: 16 }}>
            Page Not Found
          </h1>
          <p style={{ fontSize: 16, color: '#6b7280', lineHeight: 1.7, marginBottom: 40 }}>
            The page you are looking for doesn't exist or has been moved.
            Let's get you back to the best F&amp;B and POS software.
          </p>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/" style={{
              background: '#CC0000', color: '#fff',
              padding: '12px 28px', borderRadius: 8, fontWeight: 600, fontSize: 15,
            }}>
              Go to Homepage
            </Link>
            <Link to="/contact" style={{
              background: '#fff', color: '#111827',
              padding: '12px 28px', borderRadius: 8, fontWeight: 600, fontSize: 15,
              border: '1px solid #e5e7eb',
            }}>
              Contact Support
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
